/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_Friend_FamilyInputs */

const en_us2_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A friend or family`)
};

const pt_br2_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amigo ou família`)
};

const es_419_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un amigo o familiar`)
};

const pt_pt2_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amigo ou família`)
};

const fr_fr2_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ami ou la famille`)
};

const de_de2_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freunde oder Familie`)
};

const it_it2_onboarding_how_heard_friend_family = /** @type {(inputs: Onboarding_How_Heard_Friend_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un amico o un familiare`)
};

/**
* | output |
* | --- |
* | "A friend or family" |
*
* @param {Onboarding_How_Heard_Friend_FamilyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_friend_family = /** @type {((inputs?: Onboarding_How_Heard_Friend_FamilyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_Friend_FamilyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_friend_family(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_friend_family(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_friend_family(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_friend_family(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_friend_family(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_friend_family(inputs)
	return en_us2_onboarding_how_heard_friend_family(inputs)
});
export { onboarding_how_heard_friend_family as "onboarding.how_heard.friend_family" }